import axios from 'axios'
import { urlBase64ToUint8Array, storage } from '@/config/functions'

const state = {
  firstLoading: false,
  name: process.env.APP_NAME,
  host: process.env.APP_HOST,
  api: process.env.API_HOST,
  env: process.env.NODE_ENV,
  super: process.env.APP_SUPER == 'true' ? true : false,
  company: null,
  pushNotificationStatus: false,
  darkMode: false
}

const getters = {
  getFirstLoading: state => state.firstLoading,
  getAppName: state => state.name,
  getAppHost: state => state.host,
  getApiHost: state => state.api,
  getEnv: state => state.env,
  getSuper: state => state.super,
  getCompany: (state, getters) => state.company,
  getPushNotificationStatus: state => state.pushNotificationStatus,
  getAuthPersistant: (state, getters, rootState, rootGetters) => rootGetters['Auth/isRemembered'],
  getDarkMode: (state, getters) => state.darkMode
}

const mutations = {
  setFirstLoading (state) {
    state.firstLoading = true
  },
  setCompany (state, payload) {
    state.company = payload.company
  },
  setPushNotificationStatus (state, payload) {
    state.pushNotificationStatus = payload.status
  },
  setDarkMode (state, payload) {
    state.darkMode = payload.darkMode
  }
}

const actions = {
  setInitialState ({ commit, getters, dispatch }) {
    return new Promise((resolve, reject) => {
      if (!getters.getFirstLoading) {
        const remember = true
        const token = storage(remember).token

        if (token) {
          const company = storage(remember).company

          commit('Auth/setAuthorization', { token, remember }, { root: true })
          commit('setCompany', { company })

          axios.get('/me').then(response => {
            const user = {
              ...response.data.user,
              canSeeFunctionalities: response.data.canSeeFunctionalities
            }

            dispatch('Auth/attemptLogin', { user, token, remember }, { root: true })
            commit('setFirstLoading')

            resolve()
          })
        } else {
          commit('setFirstLoading')
          resolve()
        }
      } else {
        resolve()
      }
    })
  },
  setCompany ({ commit, getters }, payload) {
    const company = storage(getters.getAuthPersistant).company = payload.company

    commit('setCompany', { company })
  },
  setDarkMode ({ commit, getters }, payload) {
    const darkMode = storage(getters.getAuthPersistant).darkMode = payload.darkMode

    commit('setDarkMode', { darkMode })
  },
  subscribePush ({ commit, getters }) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        if (!registration.pushManager) {
          return console.error('Push unsupported.')
        }

        registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(process.env.WEBPUSH_PUBLIC)
        }).then(subscription => {
          axios.post('/push/subscribe', subscription).then(response => {
            commit('setPushNotificationStatus', { status: true })
            storage(getters.getAuthPersistant).notifications = true
          })
        }).catch(error => {
          console.error('Push subscription error: ', error)

          commit('UI/showSnackbar', {
            color: 'error',
            text: 'Não foi possível habilitar as notificações Push. Verifique se concedeu as devidas permissões.'
          }, {
            root: true
          })
        })
      })
    }
  },
  unsubscribePush ({ commit, getters }, { skipAPI }) {
    navigator.serviceWorker.ready.then(registration => {
      registration.pushManager.getSubscription().then(subscription => {
        if (!subscription) {
          return console.log('Push not subscribed yet.')
        }

        subscription.unsubscribe().then(() => {
          if (!skipAPI) {
            axios.delete('/push/unsubscribe').then(response => {
              commit('setPushNotificationStatus', { status: false })
              storage(getters.getAuthPersistant).notifications = false
            })
          }
        }).catch(error => {
          console.error('Push unsubscription error: ', error)
        })
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/App.js